import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import AddNewProfile from '@views/ManageUsers/AddNewProfile';

const messages = defineMessages({
  title: {
    id: 'manageAccount.invite',
    defaultMessage: 'Invite',
  },
});

function InviteUserPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user }) => <AddNewProfile account_id={user?.account_id} />}
    </ManageAccountLayout>
  );
}

export default withErrorBoundary(InviteUserPage, {
  FallbackComponent: ErrorBoundaryFallback,
});
